import {Dropdown, Button, Menu} from 'antd';
import {DownOutlined} from '@ant-design/icons';
import React from 'react';

import {STRINGS, LockIcon} from '../../libs/ui/src';

import {IntercomService} from '../../services';

export const ProspectsLeftActions = ({handleActionClick, client}: any) => {
  const actionsMenu = (
    <Menu onClick={handleActionClick}>
      <Menu.Item key="tag">Tag</Menu.Item>
      <Menu.Item disabled={!client.data_credits} key="enhance">
        Enhance Data
        {!client.data_credits && (
          <LockIcon
            message={STRINGS.message_unlock_feature}
            onClick={() => IntercomService.trackIntercomEvent('enhanced_feature_request', true, !client.data_credits)}
          />
        )}
      </Menu.Item>
      <Menu.Item key="archive">Archive</Menu.Item>
    </Menu>
  );
  return (
    <div className="prospects-page__left-buttons">
      <Dropdown overlay={actionsMenu} trigger={['click']}>
        <Button type="primary" style={{marginRight: '15px'}}>
          Actions <DownOutlined />
        </Button>
      </Dropdown>
    </div>
  );
};
